import ApplicationController from './application_controller'
import Sortable from 'sortablejs'
import { addBook, showColumns, stateRowsDiscount, calcTotalByItem } from '../packs/quotation'
import { initializeSelect2 } from '../packs/autocomplete'
/* This is the custom StimulusReflex controller for the Sort Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
  */

  connect () {
    super.connect()
    this.sortable = Sortable.create(this.element, {
      animation:150,
      onEnd: this.end.bind(this)
    })
  }

  async end(){
    let elements = document.getElementById("tbody-projects")
    let itemUl = elements.getElementsByClassName("project-item-tr")
    let page = parseInt(elements.dataset.page) || 1
    let perPage = parseInt(elements.dataset.perPage) || 50
    let items = Array.from(itemUl).map((v, i)=>{
      return {id: v.dataset.sortId, position: ((page - 1) * perPage) + i + 1}
    }) 
    elements.dataset.items = JSON.stringify(items)
    await this.stimulate("SortprojectReflex#order_projects", elements)
   // showColumns()
  //initializeSelect2(".quotation_quotation_items_item_id select")
  }
  /* Reflex specific lifecycle methods.
   *
   * For every method defined in your Reflex class, a matching set of lifecycle methods become available
   * in this javascript controller. These are optional, so feel free to delete these stubs if you don't
   * need them.
   *
   * Important:
   * Make sure to add data-controller="sort" to your markup alongside
   * data-reflex="Sort#dance" for the lifecycle methods to fire properly.
   *
   * Example:
   *
   *   <a href="#" data-reflex="click->Sort#dance" data-controller="sort">Dance!</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Sort#dance"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  // Assuming you create a "Sort#dance" action in your Reflex class
  // you'll be able to use the following lifecycle methods:

  // beforeDance(element, reflex, noop, reflexId) {
  //  element.innerText = 'Putting dance shoes on...'
  // }

  // danceSuccess(element, reflex, noop, reflexId) {
  //   element.innerText = '\nDanced like no one was watching! Was someone watching?'
  // }

  // danceError(element, reflex, error, reflexId) {
  //   console.error('danceError', error);
  //   element.innerText = "\nCouldn\'t dance!"
  // }

  // afterDance(element, reflex, noop, reflexId) {
  //   element.innerText = '\nWhatever that was, it\'s over now.'
  // }

  // finalizeDance(element, reflex, noop, reflexId) {
  //   element.innerText = '\nNow, the cleanup can begin!'
  // }
}
